import React from 'react';
import DayCareProviderScheduler from './DayCareProviderScheduler';
import ServiceProviderScheduler from './ServiceProviderScheduler';
import HomeHealthCareScheduler from './HomeHealthCareScheduler';
import { Box } from '@mui/material';

const Scheduler = (props) => {
  const embedded = props.selectedEmployeeId != null || props.selectedCustomerId != null;
  const isServiceProvider = props.user.comp_settings.find(setting => setting.feature_id === 102 && setting.feature_value === 'primaryBusinessType');
  const isHomeHealthCare = props.user.comp_settings.find(setting => [103, 106].includes(setting.feature_id) && setting.feature_value === 'primaryBusinessType');

  return (
    <Box sx={embedded ? {
      height: '100%',
      minHeight: 0,
      '& > .MuiBox-root': { height: '100%', minHeight: 0 },
      '& .scheduler-layout': {
        height: '100%', minHeight: 0, m: 0, p: 1, boxSizing: 'border-box',
      },
      '& .scheduler-calendar-content': { flex: 1, minHeight: 0, height: 0, mr: 0 },
      '& .scheduler-calendar-content > .MuiBox-root': { minHeight: 0 },
      '& .rbc-calendar': { height: '100% !important', minHeight: '0 !important' },
      '& .scheduler-loading-skeleton': {
        height: '100%', minHeight: 0, m: 0, p: 1, boxSizing: 'border-box', overflow: 'hidden',
      },
    } : undefined}>
      {isServiceProvider ? <ServiceProviderScheduler {...props} /> : isHomeHealthCare ? <HomeHealthCareScheduler {...props} /> : <DayCareProviderScheduler {...props} />}
    </Box>
  )
}

export default Scheduler;